/** sessionStorage lock prefix — must match CanvaSsoExchangeBootstrap. */
export const CANVA_SSO_EXCHANGE_STORAGE_PREFIX = 'revshop_canva_ex_';

/**
 * Non-empty {@code canvaExchange} one-time code from a query string, or null.
 * Empty {@code ?canvaExchange=} is treated as absent (unlike URLSearchParams.has).
 */
export function getCanvaExchangeCode(search: string): string | null {
  const code = new URLSearchParams(search).get('canvaExchange');
  return code ? code : null;
}

/**
 * True while the URL still has {@code canvaExchange} and the one-time code has not
 * been exchanged yet. Used to defer authenticated routes/API calls so 401 + Basic
 * auth headers from the gateway do not trigger the browser password dialog.
 */
export function isCanvaSsoExchangePending(search: string): boolean {
  const code = getCanvaExchangeCode(search);
  if (!code) {
    return false;
  }
  return (
    sessionStorage.getItem(`${CANVA_SSO_EXCHANGE_STORAGE_PREFIX}${code}`) !==
    'ok'
  );
}

/**
 * Whether a 401 should navigate the browser to `/login`.
 * Skipped on login routes and while a Canva SSO exchange is still pending.
 */
export function shouldRedirectToLoginOn401(
  pathname: string,
  search: string
): boolean {
  if (pathname.startsWith('/login')) {
    return false;
  }
  if (isCanvaSsoExchangePending(search)) {
    return false;
  }
  return true;
}
